<template>
    <div v-if="list !== undefined && list.length > 0">
        <swiper :options="swiperOptions" :class="[(store===0)? '' : 'picStore']">
            <swiper-slide class="pic" v-for="(item, index) in list" :key="index"
                          :style="{backgroundImage: 'url(' + item.imgUrl + ')' }" @click.native="handleClick(item.url)"/>
            <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
        <toast/>
    </div>
    <div v-else class="banner-container" :class="[(store===0)? '' : 'picStore']">
        <img src="../assets/images/default_banner.svg" class="pic">
    </div>
</template>

<script>
    import Toast from "@/components/Toast.vue";
    /*todo 輪播組件Swiper只支援vue3，要另外用外掛vue-awesome-swiper
       demo https://github.surmon.me/vue-awesome-swiper/
       swiper4-6功能中文網 https://www.swiper.com.cn/api/autoplay/19.html*/
    import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
    import 'swiper/css/swiper.css'
    export default {
        name: "BannerSlider",
        props: {
            list: { type:Array, default: Array.of([]) },  // list = [url:string, imgUrl:string]
            store: { type:Number, default: 0 }  // store = 0:首頁用, 1:商店頁用
        },
        components: {
            Toast,
            Swiper,
            SwiperSlide,
        },
        computed: {

        },
        data() {
            return {
                swiperOptions: {
                    loop: (this.list.length > 1),
                    touchMoveStopPropagation : true,//阻止touchmove冒泡事件
                    autoplay: {
                        delay: 3000,
                    },
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                    },
                }
            }
        },
        mounted() {

        },
        methods: {
            handleClick : function(url) {

                //回傳 result，外部接收到 result事件後再做處理
                this.$emit('onClickEvent', 0, url);

                // if (url !== undefined && url !== '') {
                //     //判斷是否爲問卷頁面
                //     if (url.indexOf('survey') > -1) {
                //         let isLogin = this.$auth.isAdminLogin();
                //         if (isLogin) {
                //             const userData = JSON.parse(localStorage.getItem('userInfo') || "");
                //             let name = userData.name;
                //             let tel = userData.phone;
                //             let combo = name + ';' + tel + ';APP';
                //             let crypto_ = this.$crypto.encryptText(combo);
                //             let param = encodeURIComponent(crypto_);
                //
                //
                //             this.callCheckQuestRecord(url)
                //                 .then( data => {
                //                     if (data) {
                //                         //有填寫過
                //                         this.$store.commit(mutationTypes.SHOW_TOAST, '已填寫過此問卷');
                //                     } else {
                //                         //沒有填寫過
                //                         let isCordova = !!window.cordova;
                //                         if (isCordova) {
                //                             //開啓頁面
                //                             this.$public.openUrl(url + '/' + param);
                //                         } else {
                //                             window.open(url + '/' + param);
                //                         }
                //                     }
                //                 })
                //                 .catch( error => {
                //                     this.$store.commit(mutationTypes.SHOW_TOAST, error);
                //                 });
                //
                //         } else {
                //             //沒登入的話就導到登入
                //             this.$router.push({name: 'Login'});
                //         }
                //
                //     } else {
                //         //一般的網頁
                //         let isCordova = !!window.cordova;
                //         if (isCordova) {
                //             //開啓頁面
                //             this.$public.openUrl(url);
                //         } else {
                //             window.open(url);
                //         }
                //     }
                // }
            },

            /** 取得填過問卷的記錄 */
            callCheckQuestRecord: function (url) {
                let self = this;
                return new Promise(function(resolve, reject) {
                    self.$http.fetchWithAuth`CheckCanWrite${{
                        url: url
                    }} ${ json => {
                      if (json !== undefined && json.status) {
                          if (json.data !== undefined && json.data !== null) {
                              //已經填寫過問卷: false，未填寫問卷: true
                              resolve(!json.data.canWrite);
                          } else {
                              //資料是空的
                              reject('沒有查到此問卷記錄');
                          }
                      } else {
                        reject('沒有查到此問卷記錄');
                      }
                    }}`;
                });
            },

        }

    }
</script>

<style scoped lang="less">
    //輪播用
    /deep/.swiper-container , .banner-container{
        @media(min-width: 1024px){
            margin-right: 20px;
            margin-left: 20px;
        }
        .pic{
            //新寬高比 100:108
            width: 100%;
            height: 108vw;
            display: block;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            /*@media(min-width: 768px){
                //平板打直時就只用電腦版圖片 比例暫訂980:520
                height: 53vw;
            }*/
            @media(min-width: 1024px){
                height: 520px;//最大寬度為980px
                border-radius: 10px;
            }
        }
        .swiper-pagination{
            bottom: 0;
            .swiper-pagination-bullet-active{
                background: var(--color-yellow);
            }
        }
        //商店頁用{
        &.picStore{
            margin: 10px 10px 0;
            .pic{
                height: calc((100vw - 60px) * 0.59);
                max-height: 578px;
                border-radius: 12px;
            }
        }
    }
</style>
